export default __webpack_public_path__ + "static/media/F1_2.8e3b1cac.png";